<template>
<div class="fc-page mg-page mg-performance_config_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>绩效配置</h1><p>设置教师基本工资、提成方式与阶梯规则</p></div><div class="mg-heading-actions"><v-btn  @click="showAddConfig" color="#d9363e" depressed class="mg-create">新增配置</v-btn></div></header><section class="fc-filters" aria-label="绩效配置筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectTeacherList" v-model="query.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined clearable color="#d9363e" aria-label="老师"></v-select></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="教师绩效规则"><div class="fc-list-heading"><h3>教师绩效规则</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				{{ shopStatusName(item.status) }}
			</template>

			<template v-slot:item.bonusType="{item}">
				{{ bonusTypeName(item.bonusType) }}
			</template>

			<template v-slot:item.priceType="{item}">
				<span v-if="item.priceType === '1'">按课程原价计算</span>
				<span v-if="item.priceType === '2'">按消课价计算</span>
				<span v-if="item.priceType === '3'">按设定的提成价格计算</span>
			</template>

			<template v-slot:item.stepDesc="{item}">
				<div class="mt-2">
					<div v-for="(step,index) in item.stepList" :key="index" class="mb-2" >
						<!-- <span v-if="item.bonusType !== '4'">满{{step.stepCount}}, 每课时奖励 {{step.price}} 元</span> -->
						<span v-if="item.bonusType === '1'">满{{step.stepCount}}课时,每课时奖励 {{step.price}} 元</span>
						<span v-if="item.bonusType === '2'">满{{step.stepCount}}到课人次,每人次奖励 {{step.price}} 元</span>
						<span v-if="item.bonusType === '3'">满{{step.stepCount}}次课,每次课奖励 {{step.price}} 元</span>
						<span v-if="item.bonusType === '4'">第{{step.stepCount}}节开始, 分成比例{{step.percent}}%</span>
					</div>
				</div>

			</template>



			<template v-slot:item.action="{item}">
				<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>
			</template>
		<template v-slot:item.baseWage="{item}"><span class="fc-number">{{item.baseWage}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="设置绩效方式" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>设置老师的绩效方式</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭设置绩效方式" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12" sm="6">
						<v-select :items="selectTeacherList" v-model="add.config.teacher" item-text="trueName"
							item-value="id" label="教师" dense outlined clearable color="#d9363e" aria-label="教师"></v-select>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="基本工资" type="number" v-model="add.config.baseWage" dense outlined color="#d9363e" aria-label="基本工资"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-select :items="bonusTypeItems" v-model="add.config.bonusType" item-text="text"
							item-value="id" label="提成计算方式" dense outlined color="#d9363e" aria-label="提成计算方式"></v-select>
					</v-col>
					<v-col cols="12" sm="6" v-if="add.config.bonusType=='4'">
						<v-select :items="priceTypeItems" v-model="add.config.priceType" item-text="text"
							item-value="id" label="价格方式" dense outlined color="#d9363e" aria-label="价格方式"></v-select>
					</v-col>

				</v-row>
				<v-row dense v-for="(item,index) in add.config.stepItems" :key="index">
					<v-col cols="5">
						<v-text-field label="满多少" type="number" v-model="item.stepCount" dense outlined color="#d9363e" aria-label="满多少">
						</v-text-field>
					</v-col>
					<v-col cols="5" v-if="add.config.bonusType !== '4'">
						<v-text-field label="单价多少" type="number" v-model="item.price" dense outlined color="#d9363e" aria-label="单价多少"></v-text-field>
					</v-col>
					<v-col cols="5" v-else>
						<v-text-field label="分成比例(X%)" type="number" v-model="item.percent" dense outlined color="#d9363e" aria-label="分成比例(X%)"></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-btn class="mt-2" x-small v-if="index ===0" color="info" @click="addRow">再加一个</v-btn>
						<v-btn class="mt-2" x-small v-if="index > 0" color="error" @click="deleteRow(index)">删除
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddConfig" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="修改绩效配置" v-model="update.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>修改绩效配置</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改绩效配置" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-text-field label="基本工资" type="number" v-model="update.config.baseWage" dense outlined color="#d9363e" aria-label="基本工资"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-select :items="bonusTypeItems" v-model="update.config.bonusType" item-text="text"
							item-value="id" label="提成计算方式" dense outlined color="#d9363e" aria-label="提成计算方式"></v-select>
					</v-col>
					<v-col cols="12" v-if="update.config.bonusType=='4'">
						<v-select :items="priceTypeItems" v-model="update.config.priceType" item-text="text"
							item-value="id" label="价格计算方式" dense outlined color="#d9363e" aria-label="价格计算方式"></v-select>
					</v-col>
				</v-row>
				<v-row dense v-for="(item,index) in update.config.stepItems" :key="index">
					<v-col cols="5">
						<v-text-field label="满多少" type="number" v-model="item.stepCount" dense outlined color="#d9363e" aria-label="满多少">
						</v-text-field>
					</v-col>
					<v-col cols="5" v-if="update.config.bonusType !== '4'">
						<v-text-field label="单价多少" type="number" v-model="item.price" dense outlined color="#d9363e" aria-label="单价多少"></v-text-field>
					</v-col>
					<v-col cols="5" v-if="update.config.bonusType === '4'">
						<v-text-field label="分成比例(X%)" type="number" v-model="item.percent" dense outlined color="#d9363e" aria-label="分成比例(X%)"></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-btn class="mt-2" x-small v-if="index ===0" color="primary" @click="addUpdateRow">再加一个
						</v-btn>
						<v-btn class="mt-2" x-small v-if="index > 0" color="error"
							@click="update.config.stepItems.splice(index,1)">删除</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateConfig" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "performance-config-list",
		data() {
			return {
				showItemId: "",
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '绩效方式配置',
						disabled: true
					},
				],
				shopId:"",
				query: {
					loading: false,
					page: 1,
					size: 20,
					teacher:""
				},
				data: {
					total: 0,
					headers: [
						{
							text: '教师姓名',
							value: 'teacherName',
							sortable: false,
						
						},
						{
							text: '基本工资',
							value: 'baseWage',
							sortable: false,
						
						},
						{
							text: '绩效方式',
							value: 'bonusType',
							sortable: false,
							
						},
						{
							text: '分成计算价格',
							value: 'priceType',
							sortable: false,
							
						},
						{
							text: '奖励阶梯',
							value: 'stepDesc',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectTeacherList:[],
				priceTypeItems:[
					{id:"1",typeName:"按课程标准价"},
					{id:"2",typeName:"按学员扣费价"},
					{id:"3",typeName:"按实际收入价"}
				],
				bonusTypeItems: [{
						id: "1",
						text: "按核销课时数提成,核销1课时奖励x元"
					},
					{
						id: "2",
						text: "按到课学生人次提成,到课1人次奖励x元"
					},
					{
						id: "3",
						text: "按上课节数提成,每节课奖励x元"
					},
					{
						id: "4",
						text: "按比例分成"
					},
				],
				priceTypeItems:[
					{id:"1",text:"按课程标准价计算"},
					{id:"2",text:"按实际扣费价计算"},
					{id:"3",text:"按设定的提成价格计算"}
				],
				add: {
					dialog: false,
					config: {
						shopId: "",
						teacher:"",
						baseWage:"",
						bonusType: "",
						priceType:"",
						stepItems: [{
							stepCount: "1",
							price: "",
							percent:""
						}]
					},
				},
				update: {
					dialog: false,
					config: {
						configId: "",
						baseWage:"",
						bonusType: "",
						stepItems: [],
						priceType:""
					},
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getTeacherListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			addRow() {
				if (this.add.config.stepItems.length >= 5) {
					this.$noty.error("最多5个阶梯");
					return
				}
				this.add.config.stepItems.push({
					stepCount: "",
					price: ""
				});
			},
			addUpdateRow() {
				if (this.update.config.stepItems.length >= 5) {
					this.$noty.error("最多5个阶梯");
					return
				}
				this.update.config.stepItems.push({
					stepCount: "",
					price: ""
				});
			},
			deleteRow(index) {
				if (index < 1) {
					this.$noty.error("最少要1个梯度");
					return
				}
				this.add.config.stepItems.splice(index, 1);
			},

			getTableDataList() {
				const that = this;
				this.query.loading = true;

			
				let url = `/sys/performance/config/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				

				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						
						console.log(that.data.list);

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			shopStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			shopStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			bonusTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				} else if (state === "3") {
					color = "warning";
				}else if (state === "4") {
					color = "primary";
				}

				return color;
			},
			bonusTypeName(state) {
				let name = "";
				this.bonusTypeItems.forEach((item, index) => {
					if (item.id === state) {
						name = item.text;
					}
				})
				return name;
			},

			showAddConfig(item) {
				this.add.dialog = true;
			
				this.add.config.bonusType = "";
				this.add.config.stepItems = [{
					stepCount: "1",
					price: ""
				}];
			},
			submitAddConfig() {

				if (!this.add.config.teacher) {
					this.$noty.error('请选择教师');
					return
				}
				
				if (!this.add.config.bonusType) {
					this.$noty.error('请选择提成计算方式');
					return
				}
				
				if(this.add.config.bonusType == "4"){
					if (!this.add.config.priceType) {
						this.$noty.error('按比例分成模式,价格计算方式不能为空');
						return
					}
				}

				let errorMsg = "";
				try {
					console.log(this.add.config.stepItems);
					this.add.config.stepItems.forEach((item, index) => {
						let rowCount = index + 1;
						console.log("item",item);
						if (!item.stepCount) {
							errorMsg = '第' + rowCount + '行数量不能为空';
							throw Error()
						}
						
						if(this.add.config.bonusType !== '4'){
							if (!item.price) {
								errorMsg = '第' + rowCount + '行价格不能为空';
								throw Error()
							}
						}else{
							if (!item.percent) {
								errorMsg = '第' + rowCount + '行分成比例不能为空';
								throw Error()
							}
						}
						
					});
				} catch(error) {
					// 跳出循环后要做的操作
					console.log(error);
					this.$noty.error(errorMsg);
					return
				}


				// api
				const that = this;
				let url = `/sys/performance/config/create`;
				let postData = {
					...this.add.config
				}
				postData.shopId = this.shopId;

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			showUpdate(item) {
				this.update.dialog = true;
				this.update.config.configId = item.id;
				this.update.config.baseWage = item.baseWage;
				this.update.config.bonusType = item.bonusType;
				this.update.config.stepItems = JSON.parse(JSON.stringify(item.stepList))
				this.update.config.priceType = item.priceType;
				console.log(this.update.config.stepItems);
			},
			submitUpdateConfig(){
				
				if (!this.update.config.bonusType) {
					this.$noty.error('请选择提成计算方式');
					return
				}
				if(this.update.config.bonusType == "4"){
					if (!this.update.config.priceType) {
						this.$noty.error('按比例分成模式,价格计算方式不能为空');
						return
					}
				}
				
			
				let errorMsg = "";
				try {
				  
					this.update.config.stepItems.forEach((item, index) => {
						let rowCount = index + 1;
						if (!item.stepCount) {
							errorMsg = '第' + rowCount + '行数量不能为空';
							throw Error()
						}
						if(this.update.config.bonusType !== '4'){
							if (!item.price) {
								errorMsg = '第' + rowCount + '行价格不能为空';
								throw Error()
							}
						}else{
							if (!item.percent) {
								errorMsg = '第' + rowCount + '行分成比例不能为空';
								throw Error()
							}
						}
					});
				} catch(error) {
					// 跳出循环后要做的操作
					console.log(error);
					this.$noty.error(errorMsg);
					return
				}
				
				
			
				
				
				// api
				const that = this;
				let url = `/sys/performance/config/update`;
				let postData = {
					...this.update.config
				}
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							that.update.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
				
			},
			
			getTeacherListForSelect(){
				
				if (!this.shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+this.shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			deepCopy(obj, cache = []) {
				// 如果为普通数据类型，则直接返回，完成拷贝
				if (obj === null || typeof obj !== "object") {
					return obj
				}
				// cache用来储存原始值和对应拷贝数据，在递归调用deepCopy函数时，如果本次拷贝的原始值在之前已经拷贝了，则直接返回储存中的copy值，这样的话就不用再循环复制本次原始值里面的每一项了。
				// 还有一个更为重要的作用，假如原始值里面嵌套两个引用地址相同的对象，使用cache可以保证拷贝出来的copy值里面两个对象的引用地址也相同。
				// 如果find查找的是一个空数组，则不会执行
				const hit = find(cache, c => c.original === obj)
				if (hit) {
					return hit.copy
				}
				// 定义拷贝的数据类型
				const copy = Array.isArray(obj) ? [] : {}
				// 用来记录拷贝的原始值和copy值
				cache.push[{
					original: obj,
					copy
				}]
				// 递归调用深拷贝函数，拷贝对象中的每一个值
				Object.keys(obj).forEach(key => {
					copy[key] = deepCopy(obj[key], cache)
				})
				return copy
			},



		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
